import React from 'react';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../components/foundations/Icon';
import { ENTRY_SURFACES, TRANSLATION_KEY } from '../constants';
import { useSlackAgent } from '../slackAgentContext';
import css from './AddToSlackAction.css';

const AddToSlackAction = () => {
    const slackAgent = useSlackAgent();
    if (!slackAgent?.needsWorkspace) return null;

    return (
        <button
            type="button"
            className={css.addAction}
            onClick={() => slackAgent.openConnect(ENTRY_SURFACES.ANSWER_ACTION)}
        >
            <Icon
                name="share"
                type={IconTypes.TABLER}
                size={IconSizes.X_SMALL}
                variant={IconVariants.LIGHT}
                interactive={false}
                className={css.addIcon}
            />
            <Translate id={`${TRANSLATION_KEY}.ADD_TO_SLACK`} />
        </button>
    );
};

export default AddToSlackAction;
